// extracted by mini-css-extract-plugin
export default {"notificationBar":"notificationBar_notificationBar__VYaQz","dismissErrorButton":"notificationBar_dismissErrorButton__jO3B-"};